module.exports = __webpack_public_path__ + "/build/web/images/register-training@2x.485c030c5db58bd7bcccf63e87e39815.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/register-training@2x.jpg
// module id = 192
// module chunks = 13